import React, { useCallback } from 'react';
import { getVisitPdf } from '../../services/api';
import { ReadonlyPdfView } from '../documents/ReadonlyPdfView';

interface ReadonlyChartViewProps {
  visitId: string;
  /**
   * Render the chart of a soft-deleted visit. Without it the PDF route 404s,
   * so the deleted-tasks view would show a load failure instead of the chart.
   */
  includeDeleted?: boolean;
}

export const ReadonlyChartView: React.FC<ReadonlyChartViewProps> = ({
  visitId,
  includeDeleted = false,
}) => {
  const loadSource = useCallback(async () => {
    const response = await getVisitPdf({
      path: { visit_id: visitId },
      // Only sent when asked for, so every existing caller keeps the URL it had
      // rather than gaining an explicit false.
      ...(includeDeleted && { query: { include_deleted: true } }),
    });
    if (!response.data) return null;
    const url = URL.createObjectURL(
      new Blob([response.data as BlobPart], { type: 'application/pdf' })
    );
    return { src: url, cleanup: () => URL.revokeObjectURL(url) };
  }, [visitId, includeDeleted]);

  return (
    <ReadonlyPdfView
      loadSource={loadSource}
      title='Chart Review'
      errorText='Failed to load chart review. Please try again.'
    />
  );
};
